import {
  productSchema,
  type CreateProductInput,
  type Product,
  type UpdateProductInput,
} from '@ai-sales/shared'
import { z } from 'zod'
import { apiRequest } from '../lib/api-client.js'

export async function fetchProducts(workspaceId: string): Promise<Product[]> {
  return apiRequest(`/workspaces/${workspaceId}/products`, z.array(productSchema))
}

export async function createProduct(
  workspaceId: string,
  input: CreateProductInput,
): Promise<Product> {
  return apiRequest(`/workspaces/${workspaceId}/products`, productSchema, {
    method: 'POST',
    body: input,
  })
}

export async function updateProduct(
  workspaceId: string,
  productId: string,
  input: UpdateProductInput,
): Promise<Product> {
  return apiRequest(`/workspaces/${workspaceId}/products/${productId}`, productSchema, {
    method: 'PATCH',
    body: input,
  })
}

export async function deleteProduct(workspaceId: string, productId: string): Promise<void> {
  await apiRequest(
    `/workspaces/${workspaceId}/products/${productId}`,
    z.object({ removed: z.literal(true) }),
    { method: 'DELETE' },
  )
}
